import AdaptiveImage from "../../../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js";

export default new AdaptiveImage({
    uri: __webpack_public_path__ + "5074d772c847f9a7be1cdc8039afaf48.jpg","uri@2x": __webpack_public_path__ + "0b6bceb4ebb1d0f3e8f120ccc5747fc7.jpg","uri@3x": __webpack_public_path__ + "23cf714442f235486bda87e3ab586fc6.jpg",
    width: 320,
    height: 568
});